import React from "react";
import { Modal } from "react-bootstrap";
import { CommonButton } from "../Input";

/**
 * CommonConfirmModal - A premium confirmation modal for destructive actions.
 *
 * Props:
 *   show       {boolean}  Visibility
 *   onHide     {function} Close callback
 *   onConfirm  {function} Action callback
 *   title      {string}   Modal title
 *   message    {string}   Confirmation text
 *   confirmText{string}   Text for the confirm button
 *   cancelText {string}   Text for the cancel button
 */
const CommonConfirmModal = ({
  show,
  onHide,
  onConfirm,
  title = "Confirmation",
  message = "Are you sure you want to perform this action?",
  confirmText = "Delete",
  cancelText = "Cancel",
  variant = "danger",
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Body className="p-4 text-center">
        <div className="mb-4">
          <i
            className={`fas fa-exclamation-triangle text-${variant} mb-3`}
            style={{ fontSize: "48px" }}
          ></i>
          <h4 className="fw-bold text-black mb-2">{title}</h4>
          <p className="text-muted fs-14 mb-0">{message}</p>
        </div>
        <div className="d-flex justify-content-end gap-2">
          <CommonButton
            variant="secondary"
            className="px-4 py-2 "
            onClick={onHide}
          >
            {cancelText}
          </CommonButton>
          <CommonButton
            variant={variant}
            className={`px-4 py-2 text-white border-0`}
            onClick={() => {
              onConfirm();
              onHide();
            }}
            style={{
              backgroundColor: variant === "danger" ? "#ff5e5e" : undefined,
              minWidth: "120px",
            }}
          >
            {confirmText}
          </CommonButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CommonConfirmModal;
